export const vehicleService = {
  getUserVehicle: (data) => window.axios.post("get-user-vehicle", data),
  getVehicleMake: (data) => window.axios.post("get-all-vehicle-make", data),
  showVehicleMake: (data) => window.axios.post("show-vehicle-make", data),
  showChargerType: (data) => window.axios.post("show-charger-type", data),
  addVehicleMake: (data) => window.axios.post("add-vehicle-make", data),
  updateVehicleMake: (data) => window.axios.post("update-vehicle-make", data),
  deleteVehicleMake: (data) => window.axios.post("delete-vehicle-make", data),
  getMakeVehicles: (data) => window.axios.post("get-make-vehicles", data),
  getChargerTypes: (data) => window.axios.post("get-charger-types", data),
  getBatterySizes: (data) => window.axios.post("get-battery-sizes", data),
  getVehicleModel: (data) => window.axios.post("get-all-vehicle-model", data),
  showVehicleModel: (data) => window.axios.post("show-vehicle-model", data),
  deleteVehicleModel: (data) => window.axios.post("delete-vehicle-model", data),
  updateVehicleModel: (data) => window.axios.post("update-vehicle-model", data),
  addVehicleModel: (data) => window.axios.post("add-vehicle-model", data),
  getModelVehicles: (data) => window.axios.post("get-model-vehicle", data),
  addOrUpdateUserVehicle: (data) =>
    window.axios.post("add-or-update-user-vehicle", data),
  showUserVehicle: (data) => window.axios.post("show-user-vehicle", data),
  deleteUserVehicle: (data) => window.axios.post("delete-user-vehicle", data),
  getChargerType: (data) => window.axios.post("get-charger-type", data),
  addChargerType: (data) => window.axios.post("add-charger-type", data),
  updateChargerType: (data) => window.axios.post("update-charger-type", data),
  deleteChargerType: (data) => window.axios.post("delete-charger-type", data),
  getBatterySize: (data) => window.axios.post("get-battery-size", data),
  showBatterySize: (data) => window.axios.post("show-battery-size", data),
  addBatterySize: (data) => window.axios.post("add-battery-size", data),
  updateBatterySize: (data) => window.axios.post("update-battery-size", data),
  deleteBatterySize: (data) => window.axios.post("delete-battery-size", data),
  getAllModelVehicles: (data) =>
    window.axios.post("get-all-model-vehicle", data),
  getAllChargerTypes: (data) =>
    window.axios.post("get-charger-type-list", data),
};
